import React from 'react';

import { BASE_COSTING_TAB_ID } from './costingOptionUtil';

const CostingOptionTabs = ({ options = [], activeTabId, onTabChange, onAddNewOption, disabled = false }) => {
	return (
		<div className="costing-option-tabs d-flex justify-content-between align-items-center px-3">
			<ul className="costing-option-tab-list d-flex align-items-center">
				<li
					className={`regular-14 ${activeTabId === BASE_COSTING_TAB_ID ? 'active' : ''}`}
					onClick={() => onTabChange(BASE_COSTING_TAB_ID)}
				>
					Base costing
				</li>
				{options.map((option) => (
					<li
						key={`costing_option_tab_${option.id}`}
						className={`regular-14 ${activeTabId === option.id ? 'active' : ''}`}
						onClick={() => onTabChange(option.id)}
					>
						{option.label}
					</li>
				))}
			</ul>
			<button
				type="button"
				className="button text new-costing-option-btn d-flex align-items-center"
				disabled={disabled}
				onClick={onAddNewOption}
			>
				<img src={`${process.env.PUBLIC_URL}/icons/add-round.svg`} alt="add" />
				<span className="regular-14 ml-1">New option</span>
			</button>
		</div>
	);
};

export default CostingOptionTabs;
